// src/components/RouteMemory.tsx
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const KEY = "__returnToRoute";

export default function RouteMemory() {
  const loc = useLocation();
  const nav = useNavigate();

  // Record the current route whenever it changes
  useEffect(() => {
    try {
      sessionStorage.setItem(KEY, loc.pathname + loc.search);
    } catch {}
  }, [loc.pathname, loc.search]);

  // On mount (and whenever pathname is "/"), jump back to last known route
  useEffect(() => {
    if (loc.pathname === "/") {
      try {
        const r = sessionStorage.getItem(KEY);
        if (r && r !== "/") nav(r, { replace: true });
      } catch {}
    }
  }, [loc.pathname, nav]);

  return null;
}
